import { _request } from './api';

export const list = date => {
  const params = date;

  return new Promise((resolve, reject) => {
    return _request({
      target: 'archive',
      method: 'GET',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const item = date => {
  const params = date;

  return new Promise((resolve, reject) => {
    return _request({
      target: 'archive/item',
      method: 'GET',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const edit = (date, archive_guid) => {
  const params = date;

  return new Promise((resolve, reject) => {
    return _request({
      target: `archive/${archive_guid}`,
      method: 'PUT',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};
